export function checkData(data) {
  if ((data != null && data != undefined && data != "") || data == "0") {
    return true;
  }
  return false;
}

export const isEmpty = (data) => {
  if (!checkData(data)) return true;
  if (data.constructor == Array && data.length < 1) return true;
  else if (data.constructor == String && data.length < 1) return true;
  else if (data.constructor == Object && Object.keys(data).length == 0)
    return true;
  else return false;
};

export const SUCCESS_TOAST = "success_toast";
export const REMOVE_TOAST = "remove_toast";

export const MAILCHIMP_API =
  "https://itauditsolution.us17.list-manage.com/subscribe/post?u=495ec3db255706cb6d8e10a6f&amp;id=0e8f38fcaa&amp;f_id=00115ae0f0";
